import OpenAI from "openai";

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true,
});

export async function transcribeAudio(audioBlob) {
  const file = new File([audioBlob], "inspection.webm", { type: "audio/webm" });

  const response = await openai.audio.transcriptions.create({
    file,
    model: "whisper-1",
    prompt: "CAT 982 wheel loader inspection. Terms: PASS, FAIL, MONITOR, transmission, radiator, differential, hydraulic, bucket, axle, duo-cone, SMU.",
  });

  return response.text;
}